var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgI2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1657",
    "data-name": "Group 1657",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 21.745,
    viewBox: "0 0 24 21.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    width: 24,
    height: 21.745,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1656",
    "data-name": "Group 1656",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M8.638,117.239c-1.446,0-2.891.008-4.337,0a7.782,7.782,0,0,1-1.246-.1A3.46,3.46,0,0,1,.08,114.064a7.072,7.072,0,0,1,.351-3.5,5.193,5.193,0,0,1,4.53-3.748A40.381,40.381,0,0,1,12.2,106.8a5.529,5.529,0,0,1,5.009,5.259,8.373,8.373,0,0,1-.02,2.079,3.563,3.563,0,0,1-3.746,3.1c-.052,0-.1,0-.157,0H8.638Zm0-1.675c1.463,0,2.926.007,4.389-.005a5.3,5.3,0,0,0,1.087-.112,1.676,1.676,0,0,0,1.366-1.288,4.5,4.5,0,0,0-4.437-5.853c-1.548.058-3.1.04-4.649.012a4.511,4.511,0,0,0-4.624,5.664,1.779,1.779,0,0,0,1.5,1.481,5.8,5.8,0,0,0,1.037.1c1.446.01,2.891,0,4.337,0",
    transform: "translate(0 -95.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M37.592,4.749A4.732,4.732,0,1,1,42.36,9.482a4.731,4.731,0,0,1-4.769-4.733m1.674-.032A3.057,3.057,0,1,0,42.33,1.675a3.064,3.064,0,0,0-3.064,3.043",
    transform: "translate(-33.662 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M157.883,103.6a15.836,15.836,0,0,1,2.012.236,4.8,4.8,0,0,1,3.647,4.553,6.857,6.857,0,0,1-.06,1.352,3.061,3.061,0,0,1-2.8,2.546,9.6,9.6,0,0,1-1.357-.007.833.833,0,1,1,.054-1.664c.451-.024.908-.013,1.353-.078a1.177,1.177,0,0,0,1.064-1.059,3.33,3.33,0,0,0-3.453-4.14c-.54.008-1.08.013-1.62,0a.834.834,0,0,1-.887-.828.851.851,0,0,1,.886-.838c.191-.011.383,0,.575,0h.575l.008-.067",
    transform: "translate(-139.549 -92.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M138.688,28.983a3.706,3.706,0,0,1-2.364-.83c-.524-.416-.63-.88-.306-1.3s.792-.42,1.327-.021A2.19,2.19,0,1,0,140,23.354a2.155,2.155,0,0,0-2.225-.22.8.8,0,0,1-1.057-.288.74.74,0,0,1,.076-1,1.725,1.725,0,0,1,.621-.362,3.8,3.8,0,0,1,4.113,1,3.734,3.734,0,0,1,.738,4.167,3.8,3.8,0,0,1-3.579,2.341",
    transform: "translate(-121.634 -19.023)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI2);
export default __webpack_public_path__ + "static/media/i2.eb322f97c6d0bf85ce1b490ab7070182.svg";
export { ForwardRef as ReactComponent };